import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RowSelectionEffects } from 'app/state/row-selection/row-selection.effects';
import { rowSelectionFeature } from 'app/state/row-selection/row-selection.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(rowSelectionFeature), EffectsModule.forFeature([RowSelectionEffects])],
})
export class RowSelectionStateModule {}
